import axios from "axios";
import { batchService } from "../../services/batch.service";
import { batchConstant } from "../constants/batch.constant";
import { apiUrl } from "../../constant";

const getHistoryPending = () => ({
    type: batchConstant.GET_HISTORY_STATUS_PENDING,
});
const getHistoryFailed = () => ({
    type: batchConstant.GET_HISTORY_STATUS_PENDING,
});
const getHistorySuccess = (response) => ({
    type: batchConstant.GET_HISTORY_STATUS_SUCCESS,
    payload: response,
});
export const getOrderHistory = (data) => {
    return (dispatch) => {
        dispatch(getHistoryPending());
        batchService.getHistoryService(data).then((result) => {
            dispatch(getHistorySuccess(result.data));
        }).catch((error) => {
            dispatch(getHistoryFailed());
        })
    };
};

export const saveMailLabelForm = (data) => {
    return () => {
        return batchService.saveMailLabelService(data);
    };
};

const getCSVSuccess = (response) => ({
    type: batchConstant.GET_CSV_STATUS_SUCCESS,
    payload: response,
});
export const getOrdersCsv = (data) => {
    return (dispatch) => {
        batchService.getOrderCsvService(data).then((result) => {
            dispatch(getCSVSuccess(result.data.Entity));
        }).catch((error) => {
            dispatch(getCSVSuccess(error));
        })
    };
};

export const getDetailedStatement = (data) => {
    return () => {
        return batchService.getDetailedStatementService(data);
    };
};

export const generateBarCode = (data) => {
    return axios.post(`${apiUrl}/GenerateBarCodeByOrderNumber`, data);
};

export const getShipmentDetailsById = (id) => {
    return axios.get(`${apiUrl}/api/getExistingOrderDetailsById?id=${id}`);
};